export default "__VITE_ASSET__DSuf06bO__"